// The order of groups and fields inside groups is IMPORTANT. It will do the sorting of columns following the sequence from here.
// However, on UI they will be sorted alphabetically
export const seasonsExportFields = [
  {
    titleIntlKey: "seasons.columns.configuration.title",
    fields: [
      "configurationFoulsAllowedPersonal",
      "configurationFoulsAllowedTechnical",
      "configurationFoulsUntilBonus",
      "configurationHalfTimeDuration",
      "configurationPeriodBreakDuration",
      "configurationShotClockLength",
    ],
  },
  {
    titleIntlKey: "seasons.columns.season.title",
    fields: [
      "seasonId",
      "forceSeasonId",
      "externalId",
      "ageGroup",
      "discipline",
      "durationFull",
      "startDate",
      "endDate",
      "eventType",
      "gender",
      "grade",
      "includeInStatistics",
      "internationalReference",
      "liveDataAvailable",
      "liveVideoAvailable",
      "lockStandings",
      "nameLatin",
      "nameLocal",
      "nameShortLatin",
      "nameShortLocal",
      "representation",
      "seasonType",
      "standard",
      "status",
      "videoProduction",
      "year",
    ],
  },
  {
    titleIntlKey: "seasons.columns.fixtureProfile.title",
    fields: ["fixtureProfileId", "fixtureProfileExternalId", "fixtureProfileName"],
  },
  {
    titleIntlKey: "seasons.columns.standingConfiguration.title",
    fields: ["standingConfigurationId", "standingConfigurationExternalId", "standingConfigurationName"],
  },
  {
    titleIntlKey: "seasons.columns.leaderCriteria.title",
    fields: ["leaderCriteriaId", "leaderCriteriaName"],
  },
  {
    titleIntlKey: "seasons.columns.rosterConfiguration.title",
    fields: [
      "rosterConfigurationFixtureBibEdit",
      "rosterConfigurationFixtureRosterLock",
      "rosterConfigurationSeasonRosterLock",
      "rosterConfigurationSeasonRosterStatusAllowed",
      "rosterConfigurationWindowCloseDate",
      "rosterConfigurationWindowOpenDate",
      "rosterConfigurationPublishFixtureRosterRolesInMinutes",
      "rosterConfigurationPublishSeasonRosterRolesInHours",
    ],
  },
  {
    titleIntlKey: "seasons.columns.social.title",
    fields: ["socialFacebook", "socialInstagram", "socialTwitter", "socialWebsite", "socialWikipedia"],
  },
];

export const defaultSeasonsExportFieldNames = [
  "seasonId",
  "ageGroup",
  "discipline",
  "startDate",
  "endDate",
  "gender",
  "nameLocal",
  "representation",
  "seasonType",
  "standard",
  "status",
  "year",
];
